import { __rest } from "tslib";
import { apiHolder, getIn18Text, api, apis } from 'api';
import React, { useState, useEffect, useRef } from 'react';
import { message } from 'antd';
const systemApi = apiHolder.api.getSystemApi();
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const roleApi = api.requireLogicalApi(apis.edmRoleApiImpl);
const isElectron = systemApi.isElectron();
const QI_YU_CONFIG = isElectron
    ? { referrer: 'https://qiye.163.com/lingxipc', title: getIn18Text('WANGYILINGXIBANGONGZHUO') }
    : { referrer: 'https://qiye.163.com/qijianxb', title: getIn18Text('WANGYILINGXIBANGONGWANG') };
export const handleKf = (orgConf) => {
    var _a;
    trackApi.track(process.env.BUILD_ISELECTRON ? 'client_lx_service' : 'web_lx_service');
    const user = systemApi.getCurrentUser();
    const uid = ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || undefined;
    const name = (user === null || user === void 0 ? void 0 : user.id) || (user === null || user === void 0 ? void 0 : user.nickName) || getIn18Text('WANGYISHOUHOUGOUTONGX') + orgConf.corpId + orgConf.corpName + orgConf.domain;
    const pid = systemApi.doGetProductInfo().productVersionId;
    const LINGXI_TITLE = pid === 'sirius' ? getIn18Text('ZUNXIANGXINBW') : pid === 'ultimate' ? getIn18Text('QIJIANXINBW') : systemApi.doGetProductInfo().productVersionName + 'web';
    const TITLE_PREFIX = process.env.BUILD_ISEDM ? getIn18Text('WANGYIWAIMAOTONG') : LINGXI_TITLE;
    const shuntId = pid === 'sirius' ? 1093036 : pid === 'ultimate' ? 1101997 : 1101997;
    const config = {
        uid,
        robotId: 9091,
        referrer: isElectron ? QI_YU_CONFIG.referrer : pid === 'sirius' ? 'https://qiye.163.com/zunxiangxb' : QI_YU_CONFIG.referrer,
        name: name || '网易售后沟通X3941499',
        title: isElectron ? `${TITLE_PREFIX}桌面端` : `${TITLE_PREFIX}`,
        email: user === null || user === void 0 ? void 0 : user.id,
        robotShuntSwitch: 1,
        shuntId,
        success: function () {
            console.log('succ');
            window === null || window === void 0 ? void 0 : window.ysf('open', {
                templateId: 6603268,
            });
        },
        error: function (err) {
            message.error(err);
            console.log(err);
        },
        templateId: 6603268,
        qtype: pid === 'sirius' ? 4492084 : 5506026,
        hidden: 1,
    };
    if (isElectron && process.env.BUILD_ISLINGHANG) {
        config.groupid = 480959804;
        config.qtype = 4489138;
    }
    window.ysf('config', config);
};
export const handleKfScriptLoad = (ref) => new Promise((resolve, reject) => {
    if (window.ysf)
        return resolve();
    if (ref.current)
        return reject();
    const user = systemApi.getCurrentUser();
    const pid = systemApi.doGetProductInfo().productVersionId;
    const LINGXI_TITLE = pid === 'sirius' ? getIn18Text('ZUNXIANGXINBW') : pid === 'ultimate' ? getIn18Text('QIJIANXINBW') : systemApi.doGetProductInfo().productVersionName + 'web';
    const TITLE_PREFIX = process.env.BUILD_ISEDM ? getIn18Text('WANGYIWAIMAOTONG') : LINGXI_TITLE;
    const shuntId = pid === 'sirius' ? 1093036 : pid === 'ultimate' ? 1101997 : 1101997;
    ref.current = true;
    const script = document.createElement('script');
    script.src = 'https://qiyukf.com/script/abab5b9989e6f898240067f40874a096.js?hidden=1';
    script.onload = () => {
        var _a;
        ref.current = false;
        if (window.ysf) {
            const uid = ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || undefined;
            const name = (user === null || user === void 0 ? void 0 : user.id) || (user === null || user === void 0 ? void 0 : user.nickName);
            const config = {
                uid,
                name,
                title: isElectron ? `${TITLE_PREFIX}桌面端` : TITLE_PREFIX,
                referrer: isElectron ? QI_YU_CONFIG.referrer : pid === 'sirius' ? 'https://qiye.163.com/zunxiangxb' : QI_YU_CONFIG.referrer,
                robotId: 9091,
                robotShuntSwitch: 1,
                templateId: 6603268,
                shuntId,
                qtype: pid === 'sirius' ? 4492084 : 5506026,
                hidden: 1,
            };
            if (isElectron && process.env.BUILD_ISLINGHANG) {
                config.groupid = 480959804;
                config.qtype = 4489138;
            }
            window.ysf('config', config);
            resolve();
        }
        else {
            reject();
        }
    };
    script.onerror = () => {
        ref.current = false;
        reject();
    };
    document.body.appendChild(script);
});
export const LingxiKfEntry = props => {
    const { className, style, children, onClick } = props, restProps = __rest(props, ["className", "style", "children", "onClick"]);
    const onClickFromProps = onClick || (() => { });
    const qiyuLoading = useRef(false);
    const [orgConf, setOrgConf] = useState({
        orgId: '',
        corpId: 0,
        corpName: '',
        domain: '',
    });
    const handleClick = () => {
        trackApi.track('waimao_customer_service', { action: 'click' });
        handleKfScriptLoad(qiyuLoading).then(() => {
            handleKf(orgConf);
        });
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            handleKfScriptLoad(qiyuLoading);
        }, 30000);
        return () => timer && clearTimeout(timer);
    }, []);
    useEffect(() => {
        roleApi.getKfInfo().then(data => {
            setOrgConf(data);
        });
    }, []);
    return (React.createElement("div", Object.assign({ className: className, style: style, onClick: event => {
            handleClick();
            onClickFromProps(event);
        } }, restProps), children));
};
